import { render, staticRenderFns } from "./vc-pagination.vue?vue&type=template&id=06ce9b8a&scoped=true&"
import script from "./vc-pagination.vue?vue&type=script&lang=js&"
export * from "./vc-pagination.vue?vue&type=script&lang=js&"
import style0 from "./vc-pagination.vue?vue&type=style&index=0&id=06ce9b8a&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06ce9b8a",
  null
  
)

export default component.exports